import React, { useState, useEffect } from "react";
import StatisticsTable from "./StatisticsTable";
import http from "../services/httpService.js";
import BarLoader from "react-spinners/BarLoader";
const { SERVER_BASE_URL } = require("../env");

function StatisticsPage() {
  const [programs, setPrograms] = useState([]);
  let [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await http.get(`${SERVER_BASE_URL}/my-cpes`, {
          headers: { "x-auth-token": localStorage.getItem("token") },
        });
        setPrograms(response.data);
        setLoading(false);
      } catch (e) {
        if (e.response && e.response.status == 401) {
          window.location = "/";
        }
      }
    }
    fetchData();
  }, []);

  return (
    <div className="centeral-container">
      <div className="page-top-title farsi-bold">
        ‌وضعیت آسیب‌پذیری برنامه‌ها
      </div>

      <BarLoader
        className="mt-3"
        color={"#a4b5ff"}
        loading={loading}
        size={100}
        aria-label="Loading Spinner"
        data-testid="loader"
      />

      {programs.length > 0 && (
        <StatisticsTable items={programs}></StatisticsTable>
      )}
      {programs.length <= 0 && !loading && (
        <div className="farsi">
          هنوز برنامه‌ای به لیست برنامه‌هایتان اضافه نکرده‌اید.
        </div>
      )}
    </div>
  );
}

export default StatisticsPage;
